import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  priceGroups: [
    // {
    //   id: 1,
    //   priceGroupName: 'test1',
    //   customers: 5,
    //   priceKWH: 0.05,
    //   minConsumption: 1,
    //   activateBuyAndHost: true,
    //   activateMinerHosting: true
    // }
  ],
  loading: false,
  error: null
};

const priceGroup = createSlice({
  name: 'priceGroup',
  initialState,
  reducers: {
    // Set loading state for all requests
    requestStart: state => {
      state.loading = true;
      state.error = null;
    },
    // Handle failure for all requests
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Fetch price groups success
    fetchPriceGroupsSuccess: (state, action) => {
      state.priceGroups = action.payload.data.content;
      state.loading = false;
    },
    // Create price group success
    createPriceGroupSuccess: (state, action) => {
      state.priceGroups.push({ ...action.payload, customers: 0 });
      state.loading = false;
    },
    // Update price group success
    updatePriceGroupSuccess: (state, action) => {
      state.priceGroups = state.priceGroups.map(priceGroup =>
        priceGroup.id === action.payload.id
          ? { ...priceGroup, ...action.payload }
          : priceGroup
      );
      state.loading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchPriceGroupsSuccess,
  createPriceGroupSuccess,
  updatePriceGroupSuccess
} = priceGroup.actions;

export default priceGroup.reducer;
